import React from "react";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import owlyLogo from "../../assets/OwlyByAulasneo-black.png";

/**
 * Footer component
 * Props (opcionales):
 * - logoAlt: texto alternativo del logo
 * - contactHref: URL para "Contact us"
 * - termsHref: URL para "Terms of use"
 * - reservedText: texto de derechos reservados
 */
export default function Footer({
  logoAlt = "Owly by Aulasneo",
  contactHref = "https://getowly.ai/contact",
  termsHref = "https://getowly.ai/terms-of-service",
  privacyHref = "https://getowly.ai/privacy-policy",
  cookiesHref = "https://getowly.ai/cookie-policy",
  reservedText = "©All rights reserved",
}) {
  const { t } = useTranslation("footer");
  const contactLabel = t("contact");
  const termsLabel = t("terms");
  const privacyLabel = t("privacy", { defaultValue: "Privacy Policy" });
  const cookiesLabel = t("cookies", { defaultValue: "Cookie Policy" });
  const reservedLabel = reservedText || t("reserved");
  return (
    <footer className="footer">
      <a href="https://getowly.ai" className="footer__brand" aria-label="Owly by Aulasneo">
        <img src={owlyLogo} alt={logoAlt} className="logoFooter" />
      </a>

      <nav className="footer__links" aria-label="Footer links">
        <a href={contactHref} className="footer__link">{contactLabel}</a>
        <a href={termsHref} className="footer__link">{termsLabel}</a>
        <a href={privacyHref} className="footer__link">{privacyLabel}</a>
        <a href={cookiesHref} className="footer__link">{cookiesLabel}</a>
      </nav>

      <div className="reserved">{reservedLabel}</div>
    </footer>
  );
}
